var render, staticRenderFns
import script from "./inputWithCounter.vue?vue&type=script&lang=js"
export * from "./inputWithCounter.vue?vue&type=script&lang=js"
import style0 from "./inputWithCounter.vue?vue&type=style&index=0&id=bbf3be26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports